function validateETH() {
    //guard run only if ETH field is there...
    if($("input.ETH.Address").length === 0) return;
    
    $("input.ETH.Address").change(function () {
        const val = this.value;
        if (isETHAddress(val)) {
            $(this).parents('form.js-aspnet-form').find("button.FormSubmitButton").prop("disabled", false);;
            return $(this).parent().find(".Form__Element__ValidationError").text("").hide()
        } else {
            $(this).parents('form.js-aspnet-form').find("button.FormSubmitButton").prop("disabled", true);;
            return $(this).parent().find(".Form__Element__ValidationError").text("Please enter a valid ETH address.").show()
        }
    });


    /**
     * Checks if the given string is an address
     *
     * @method isAddress
     * @param {String} address the given HEX adress
     * @return {Boolean}
    */
    var isETHAddress = function (address) {
        if (typeof address != "string") return false;
        address = address.toLowerCase();
        if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
            // check if it has the basic requirements of an address
            return false;
        } else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) {
            // If it's all small caps or all all caps, return true
            return true;
        } else {
            // Otherwise check each case
            return false;
        }
    };
}
window.addEventListener("DOMContentLoaded", validateETH);

function bindMarketoCookie()
{
    if ($("form input[value=marketo-cookie-id]").length === 0) return;

    //add Marketo cookie
    $("input[value=marketo-cookie-id]").val(GetMarketoId())
}
window.addEventListener("DOMContentLoaded", bindMarketoCookie);

// Let's Connect form on fund pages
const formCTA = () => {
    document.querySelectorAll('.page-ucits-etf .cta-link__text.pdf').forEach(element => { element.setAttribute('target', '_blank') }); //fix for pdf links to open in new tab

    const connectForm = document.querySelector('.lets-connect-form');
    if (!connectForm) return;

    // Preventing form from appearing based on default premium form behaviour
    localStorage.setItem(connectForm.getAttribute('id'), 'hidden');

    const selectors = ['.fund-documents-right-column .btn.lets-connect', 'a[data-cssclass="schedule-ico lets-connect"]', 'a.cta-link__text', '.overview_links__wrapper .lets-connect'];
    const triggers = document.querySelectorAll(selectors.join(','));

    triggers.forEach(el => {
        // For EU links (temporarily based on content)
        if (
            el.matches('a.cta-link__text') &&
            !el.innerHTML.trim().includes('Connect') && !el.innerHTML.trim().includes('Conect')
        ) return;

        el.addEventListener('click', (e) => {
            e.preventDefault();
            connectForm.classList.add('show');
            connectForm.style.display = 'block';
        });
    });


    // For dynamically added secondary nav link. React renders it after DOMContentLoaded, so listen on the
    // document; the sticky nav (ve-fundpagesecondarynav) has no .fund-page-secondary-nav-wrp wrapper or data-cssclass.
    document.addEventListener('click', (e) => {
        const link = e.target.closest('.fund-page-secondary-nav-wrp a[data-cssclass="schedule-ico lets-connect"], .overview_links__wrapper a.lets-connect');
        if (!link) return;

        e.preventDefault();
        connectForm.classList.add('show');
        connectForm.style.display = 'block';
    });
};
document.addEventListener('DOMContentLoaded', formCTA);


// Select current country in form country select input (Using the select option as this script runs before the custom-dropdown script)
const countrySelector = () => {
    //Check the AHP for the current country and select the country in the form input accordingly.
    const countries = document.querySelectorAll(".Country option");
    const ahpCountry = document.querySelector("#hdnSelectedCountry")?.attributes.value.value || "";
    const optionToSelect = [...countries].find(x => x.value.trim() == ahpCountry.trim().toLowerCase());
    if (optionToSelect) optionToSelect.selected = true;
};
document.addEventListener("DOMContentLoaded", countrySelector);